// Mapping ruolo LSSD → URL del patch/insegna del grado.
// Le immagini sono ospitate sui customer assets Emergent.

export const RANK_PATCHES = {
  "Sceriffo":              "https://customer-assets-39nsmqrw.emergentagent.net/job_sheriff-ops/artifacts/c90gdq4g_grado%20sceriffo.png",
  "Sotto Sceriffo":        "https://customer-assets-39nsmqrw.emergentagent.net/job_sheriff-ops/artifacts/lgpp8mus_grado%20sotto%20sceriffo.png",
  "Assistente Sceriffo":   "https://customer-assets-39nsmqrw.emergentagent.net/job_sheriff-ops/artifacts/tusnnqs6_Screenshot_2026-08-11_140725-removebg-preview.png",
  "Capo Divisione":        "https://customer-assets-39nsmqrw.emergentagent.net/job_sheriff-ops/artifacts/sg87j88x_grado%20capo%20divisione.png",
  "Comandante di Area":    "https://customer-assets-39nsmqrw.emergentagent.net/job_sheriff-ops/artifacts/rduedo3s_grado%20comandante%20di%20area.png",
  "Capitano":              "https://customer-assets-39nsmqrw.emergentagent.net/job_sheriff-ops/artifacts/ltutkyrc_grado%20capitano.png",
  "Tenente":               "https://customer-assets-39nsmqrw.emergentagent.net/job_sheriff-ops/artifacts/8y1npx14_grado%20tenente.png",
  "Sergente":              "https://customer-assets-39nsmqrw.emergentagent.net/job_sheriff-ops/artifacts/mt11tdo3_grado%20sergente.png",
  "Vice Sceriffo I":       "https://customer-assets-39nsmqrw.emergentagent.net/job_sheriff-ops/artifacts/2ecwvk9t_grado%20Vice%20Sceriffo%20I.png",
  "Vice Sceriffo II":      "https://customer-assets-39nsmqrw.emergentagent.net/job_sheriff-ops/artifacts/mqwbn8ko_grado%20vice%20sceriffo%20II.png",
};

export function getRankPatch(role) {
  if (!role) return null;
  return RANK_PATCHES[role] || null;
}
